module.exports = __webpack_public_path__ + "static/media/blazing-optimized.df438888.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/slides/05-why-gatsby/images/blazing-optimized.jpg
// module id = 949
// module chunks = 0